import React from "react";
import PropTypes from "prop-types";
import { Flex, Icon, Small, Popover } from "orcs-design-system";

const StatsDisplay = ({ statsConfig }) => {
  if (!statsConfig || statsConfig.length === 0) {
    return null;
  }

  return (
    <Flex alignItems="center" gap="s" flexWrap="wrap">
      {statsConfig.map((stat) => (
        <Flex key={stat.id} alignItems="center" gap="s">
          {stat.popoverContent ? (
            <Popover
              direction="top"
              width="fit-content"
              text={stat.popoverContent}
            >
              <Flex alignItems="center" gap="s">
                <Icon icon={stat.icon} color="greyDarker" />
                <Small color="greyDarker">{stat.label}</Small>
              </Flex>
            </Popover>
          ) : (
            <Flex alignItems="center" gap="s">
              <Icon icon={stat.icon} color="greyDarker" />
              <Small color="greyDarker">{stat.label}</Small>
            </Flex>
          )}
        </Flex>
      ))}
    </Flex>
  );
};

StatsDisplay.propTypes = {
  statsConfig: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      icon: PropTypes.array.isRequired,
      label: PropTypes.string.isRequired,
      popoverContent: PropTypes.node,
    })
  ),
};

export default StatsDisplay;
